module.exports = __webpack_public_path__ + "static/media/icon_signed_in.cd0dfa19.png";